import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Share, Plus, SquarePlus } from "lucide-react";

interface PWAInstallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const PWAInstallDialog = ({ open, onOpenChange }: PWAInstallDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>Installer Piktable</DialogTitle>
          <DialogDescription>
            Ajoutez Piktable sur votre écran d'accueil pour y accéder rapidement.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-semibold text-sm">
              1
            </div>
            <div className="flex items-center gap-2 pt-1">
              <span className="text-sm">Appuyez sur l'icône</span>
              <Share className="h-5 w-5 text-primary" />
              <span className="text-sm font-medium">Partager</span>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-semibold text-sm">
              2
            </div>
            <div className="flex items-center gap-2 pt-1">
              <span className="text-sm">Appuyez sur</span>
              <SquarePlus className="h-5 w-5 text-primary" />
              <span className="text-sm font-medium">Sur l'écran d'accueil</span>
            </div>
          </div>

          <div className="flex items-start gap-3">
            <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10 text-primary font-semibold text-sm">
              3
            </div>
            <p className="text-sm pt-1">
              Appuyez sur <span className="font-medium">Ajouter</span> — c'est tout !
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
